export default __webpack_public_path__ + "static/media/Resume.fdf51681.pdf";